import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';


const styles = theme => ({
    root: {
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '100vh',
        zIndex: 1,
    },
    appBar: {
        position: 'fixed',
        width: '100%',
    },
    toolbar: {
        minHeight: 44,
        paddingLeft: 0,
        paddingRight: 0,
    },
    menuButton: {
        backgroundColor: '#ff9800',
        color: '#fff',
        borderRadius: 0,
        padding: '0 16px',
        minHeight: 44,
        textTransform: 'none',
        fontSize: '1.25rem',
        fontWeight: 500,
        '&:hover': {
            backgroundColor: '#f57c00',
        },
    },
    body: {
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        paddingTop: 44,
    },
    menuPaper: {
        width: 240,
        maxHeight: 'calc(100vh - 44px)',
        overflowY: 'auto',
        backgroundColor: '#fff',
        marginTop: 0,
    },
    content: {
        backgroundColor: theme.palette.background.default,
        flex: '1 0 auto',
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        boxSizing: 'border-box',
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing.unit * 3,
        },
    },
    grow: {
        flexGrow: 1,
    }
});

class ResponsiveDrawer extends React.Component {
    state = {
        menuOpen: false,
    };

    menuButtonRef = React.createRef();

    handleMenuToggle = () => {
        this.setState({menuOpen: !this.state.menuOpen});
    };

    handleMenuClose = () => {
        this.setState({menuOpen: false});
    };

    render() {
        const {title, drawerContent, ToolbarContent, classes, children} = this.props;

        return (
            <div className={classes.root}>
                <AppBar className={classes.appBar}>
                    <Toolbar disableGutters className={classes.toolbar}>
                        <Button ref={this.menuButtonRef}
                                onClick={this.handleMenuToggle}
                                className={classes.menuButton}>
                            Меню
                        </Button>
                        <Typography variant="h6"
                                    color="inherit"
                                    noWrap
                                    className={classes.grow}
                                    style={{ textAlign: 'center' }}>
                            {title}
                        </Typography>
                        { ToolbarContent &&
                            <ToolbarContent />
                        }
                    </Toolbar>
                </AppBar>
                <Popover open={this.state.menuOpen}
                         anchorEl={this.menuButtonRef.current}
                         onClose={this.handleMenuClose}
                         anchorOrigin={{
                             vertical: 'bottom',
                             horizontal: 'left',
                         }}
                         transformOrigin={{
                             vertical: 'top',
                             horizontal: 'left',
                         }}
                         classes={{
                             paper: classes.menuPaper,
                         }}
                         PaperProps={{ square: true }}>
                    {drawerContent}
                </Popover>
                <div className={classes.body}>
                    <main className={classes.content}>
                        {children}
                    </main>
                </div>
            </div>
        );
    }

    close() {
        this.setState({menuOpen: false});
    }
}

ResponsiveDrawer.propTypes = {
    title: PropTypes.string,
    drawerContent: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    ToolbarContent: PropTypes.func,
};

export default withStyles(styles, {withTheme: true})(ResponsiveDrawer);
